var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"q-app"}},[(!_vm.loaded)?_c('div',{staticClass:"loader fixed-center"},[_c('q-spinner-pie',{attrs:{"color":"primary","size":"2em"}})],1):_c('div',[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }